import {
  SimpleGrid,
  Stack,
  GridItem,
  Drawer,
  DrawerOverlay,
  DrawerBody,
  DrawerContent,
} from "@chakra-ui/react";
import { MotionGrid, MotionGridItem } from "utils/motion";

import { motion } from "framer-motion";

import NavbarMenuItem from "components/blocks/NavbarMenuItem";
import NavbarMobileMenu from "components/blocks/NavbarMobileMenu";
import navbarContent from "utils/navbar.json";

const MotionDrawerContent = motion(DrawerContent);
const MotionDrawerBody = motion(DrawerBody);

const NavbarMenu = (props) => {
  const { isOpen, onClose, contentSlide, onAction, onAccountClick } = props;

  return (
    <Drawer
      onClose={onClose}
      isOpen={isOpen}
      placement="top"
      zIndex={999}
      autoFocus={false}
      preserveScrollBarGap
    >
      <DrawerOverlay zIndex={999}>
        <MotionDrawerContent
          bg="black.700"
          p={0}
          m={0}
          zIndex={999}
          w="100wv"
          h={["100%", "100%", "350px", "420px", "520px", "620px"]}
          pt={[null, null, "100px", "100px", "100px", "100px"]}
          px={[null, null, null, "md", "xl", "xxl"]}
          pb={[null, null, null, "md", "xl", "xxl"]}
        >
          <MotionDrawerBody
            p={0}
            m={0}
            onHoverEnd={onClose}
            display={["none", "none", "block"]}
          >
            <Menu
              slide={0}
              onClose={onClose}
              isVisible={isOpen && contentSlide === 0}
            />
            <Menu
              slide={1}
              onClose={onClose}
              isVisible={isOpen && contentSlide === 1}
            />
            <Menu
              slide={2}
              onClose={onClose}
              isVisible={isOpen && contentSlide === 2}
            />
          </MotionDrawerBody>
          <MotionDrawerBody p={0} m={0} display={["block", "block", "none"]}>
            <NavbarMobileMenu
              onClose={onClose}
              slide={contentSlide}
              onAction={onAction}
              onAccountClick={onAccountClick}
            />
          </MotionDrawerBody>
        </MotionDrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default NavbarMenu;

const Menu = ({ onClose, slide, isVisible }) => (
  <MotionGrid
    display={["none", null, "grid"]}
    position="absolute"
    w="100%"
    gap="xl"
    zIndex={isVisible ? 0 : -10}
    templateColumns="repeat(12, 1fr)"
  >
    <GridItem colSpan={[8, 8, 8, 9]}>
      <SimpleGrid
        columns={navbarContent[slide].items.length >= 4 ? 2 : 1}
        direction="column"
        justifyContent="center"
        spacingY={["xxl", "xxl", "xxl", "md", "xl", "xl"]}
        spacingX="sm"
      >
        {navbarContent[slide].items.map((item, idx) => (
          <NavbarMenuItem
            key={`${slide}-${item.id}`}
            {...item}
            id={`${slide}-${item.id}`}
            isVisible={isVisible}
            onClose={onClose}
            delay={0.1 * idx + 0.3}
          />
        ))}
      </SimpleGrid>
    </GridItem>
    {navbarContent[slide].subItems?.length > 0 && (
      <MotionGridItem
        colSpan={[4, 4, 4, 3]}
        style={{ borderLeft: "2px solid #393c41" }}
        variants={{
          hidden: { opacity: 0, transition: { delay: 0.1, duration: 0.4 } },
          visible: { opacity: 1, transition: { delay: 0.3, duration: 0.4 } },
        }}
        initial="hidden"
        animate={isVisible ? "visible" : "hidden"}
      >
        <Stack direction="column" pl="sm">
          {navbarContent[slide].subItems?.map((item, idx) => (
            <NavbarMenuItem
              {...item}
              key={idx}
              subItem
              isVisible={isVisible}
              onClose={onClose}
              delay={0.1 * idx + 0.4}
            />
          ))}
        </Stack>
      </MotionGridItem>
    )}
  </MotionGrid>
);
